// @flow

// Modules
import React from 'react';
import styled from 'styled-components';

// Assets
import { Help, Refresh } from 'assets/svg';

// Styles
import { COOL_GREY, WHITE } from 'src/styles/palettes';

/**
 * Styles
 */

const Icons = styled.div`
  display: flex;
  align-items: center;
`;

const ReloadIcon = styled(Refresh)`
  ${(props) => `width: ${props.size};`}
  ${(props) => `height: ${props.size};`}
  margin-right: 1.5em;
  color: ${WHITE};
  cursor: pointer;
  transition: transform 200ms;

  :hover {
    color: ${COOL_GREY[100]};
    transform: rotateZ(30deg);
  }
`;

const HelpIcon = styled(Help)`
  ${(props) => `width: ${props.size};`}
  ${(props) => `height: ${props.size};`}
  color: ${WHITE};
  cursor: pointer;

  :hover {
    color: ${COOL_GREY[100]};
  }
`;

/**
 * Types
 */

type PropTypes = {
  className?: any,
  size: string,
  resetConf: () => void,
  navigate: (action: string) => void
};

/*
 ** Component
 */

const InfosPlayer = (props: PropTypes): React$Element<any> => {
  const { className, resetConf, size, navigate } = props;

  return (
    <Icons className={className}>
      <ReloadIcon size={size} onClick={resetConf} />
      <HelpIcon size={size} onClick={() => navigate('challenges-help')} />
    </Icons>
  );
};

export default InfosPlayer;
